import { Check, ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

const DELIVERABLES = [
  "Full Google Business Profile audit",
  "Business description rewrite",
  "Up to five optimized service descriptions",
  "Primary & secondary category recommendations",
  "Four Google Business Profile posts",
  "Review response templates",
  "Profile implementation & quality check",
];

export const Solution = () => (
  <section
    id="offer"
    data-testid="solution-section"
    className="bg-ink py-24 text-cream sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="eyebrow mb-5 !text-emerald-300">The Solution</p>
            <h2 className="text-4xl font-extrabold tracking-tight sm:text-5xl">
              Make Your Google Business Profile Work Harder for Your Business.
            </h2>
            <p className="mt-6 text-base text-cream/70 sm:text-lg">
              The Google Maps Profile Makeover is a one-time, done-for-you
              project that turns your listing into a clear, complete reason to
              choose you.
            </p>
            <div className="mt-9 flex items-end gap-3">
              <span
                data-testid="makeover-price"
                className="font-heading text-7xl font-extrabold tracking-tighter text-cream sm:text-8xl"
              >
                $249
              </span>
              <span className="pb-3 font-heading text-sm font-bold uppercase tracking-[0.18em] text-emerald-300">
                One-time
              </span>
            </div>
            <button
              data-testid="solution-cta-button"
              onClick={() => scrollToId("#audit-form")}
              className="btn-light mt-9"
            >
              Get My Free Audit
              <ArrowRight weight="bold" size={18} />
            </button>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-cream/50">
              Implementation requires authorized manager access to your profile
              and your approval before anything goes live. Some profile
              features depend on your business category.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <ul
              data-testid="makeover-deliverables"
              className="grid grid-cols-1 gap-4 sm:grid-cols-2"
            >
              {DELIVERABLES.map((d, i) => (
                <li
                  key={i}
                  className="flex items-start gap-4 rounded-3xl border border-cream/10 bg-cream/[0.04] p-6 transition-colors duration-300 hover:border-emerald-300/30"
                >
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-pine">
                    <Check size={15} weight="bold" className="text-cream" />
                  </span>
                  <span className="font-heading text-lg font-bold leading-snug">
                    {d}
                  </span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
